import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2/dist/sweetalert2.js";
import $ from "jquery";

export default class extends Controller {
  static targets = ["submitButton", "operation", "delete", "activite", "input"];
  static values = {
    button: String,
    message: String,
    warning: String,
  };

  connect() {
    this.counter = 1;
    this.replaceCountersOnLoad();
  }

  sendAlertWhenInvalid() {
    if (this.submitButtonTarget.disabled) {
      Swal.fire({
        title: this.warningValue,
        text: this.messageValue,
        icon: "error",
        confirmButtonText: this.buttonValue,
      });
    }
  }

  modeOperatoireUpdate() {
    return [...this.operationTargets].some((operation) => {
      const checkboxes = operation.querySelectorAll("input[type=checkbox]");
      return [...checkboxes].some((checkbox) => checkbox.checked);
    });
  }

  allActiviteOpened() {
    return this.activiteTargets.every((btn) => btn.dataset.opened === "true");
  }

  enableSubmitIfAllOpened() {
    if (this.allActiviteOpened()) {
      this.submitButtonTarget.disabled = false;
    }
  }

  displayAsOpened(button) {
    if (button.dataset.opened === "false") {
      button.insertAdjacentHTML(
        "beforeEnd",
        `
          <i class="fas fa-check text-success"></i>
        `
      );
      button.dataset.opened = "true";
    }
  }

  handleActiviteOpen(event) {
    console.log($(event.currentTarget.attributes.href.value));
    $(event.currentTarget.attributes.href.value).collapse("toggle");
    this.displayAsOpened(event.currentTarget);
    this.enableSubmitIfAllOpened();
  }

  handleAddingOperation() {
    this.submitButtonTarget.disabled = true;
    // setTimeout(() => {this.replaceCounters()}, 500);
  }

  handleRemove() {
    setTimeout(() => {
      this.enableSubmitIfAllOpened();
    }, 50);
  }

  replaceCountersOnLoad() {
    const regex = /_CHANGEINJS_/g;
    this.operationTargets.forEach((operation) => {
      operation.outerHTML = operation.outerHTML.replace(regex, this.counter);
      this.counter += 1;
    });
  }

  replaceCounters() {
    console.log(this.counter);
    const regex = /_CHANGEINJS_/g;

    const lastOperation =
      this.operationTargets[this.operationTargets.length - 1];
    lastOperation.outerHTML = lastOperation.outerHTML.replace(
      regex,
      this.counter
    );
    this.counter += 1;
  }

  // Quick way to validate all activite in Mode Op Edit in development mode
  validateAll() {
    this.activiteTargets.forEach((target) => {
      target.dataset.opened = "true";
      this.displayAsOpened(target);
    });
    this.enableSubmitIfAllOpened();
  }
}
